export default __webpack_public_path__ + "static/media/footer-gallery-1.38505f4e.jpg";